export function h3d(ctx) {
    return {
        styles: {
            main: {
                bg_color: `${ctx.COLOR_BG}ff`,
                border_color: `${ctx.COLOR_BG_BORDER}ff`,
                border_width: 2,
                outline_color: `${ctx.primary}ff`,
                shadow_color: '#00000033',
                radius: 4,
            },
        },
    };
}
